import { Trans } from '@lingui/react/macro'

import { IconChevronLeft, IconChevronRight, IconChevronsLeft, IconChevronsRight, IconDots } from '@tabler/icons-react'

import { useDynamicTable } from '~/components/dynamic_table/context'

export default function Pagination() {
  const { state } = useDynamicTable()
  const { data, meta, setPage } = state
  const { current_page, total_pages, per_page } = meta
  const startPage = Math.max(1, current_page - 4)
  const endPage = Math.min(total_pages, current_page + 4)
  const showStartGap = startPage > 1

  return (
    <ul className='pagination m-0 ms-auto'>
      {current_page > 1 && (
        <li className='page-item'>
          <button type='button' className='page-link cursor-pointer d-flex' onClick={() => setPage(1)}>
            <IconChevronsLeft size={22} stroke={1} /> <Trans>first</Trans>
          </button>
        </li>
      )}
      {current_page > 1 && (
        <li className='page-item'>
          <button type='button' className='page-link cursor-pointer d-flex' onClick={() => setPage(current_page - 1)}>
            <IconChevronLeft size={22} stroke={1} /> <Trans>prev</Trans>
          </button>
        </li>
      )}
      {showStartGap && (
        <li className='page-item disabled'>
          <span className='page-link d-flex'>
            <IconDots size={22} stroke={1} />
          </span>
        </li>
      )}
      {total_pages === null ? (
        <PartialPages
          current_page={current_page}
          startPage={startPage}
          data={data}
          per_page={per_page}
          setPage={setPage}
        />
      ) : (
        <TotalPages
          endPage={endPage}
          current_page={current_page}
          total_pages={total_pages}
          startPage={startPage}
          setPage={setPage}
        />
      )}
    </ul>
  )
}

function PartialPages({ setPage, current_page, data, per_page }) {
  const from = Math.max(1, current_page - 4)
  const size = current_page - from
  return (
    <>
      {Array.from({ length: size + 1 }, (_, i) => current_page - size + i).map((p) => (
        <li key={p} className={`page-item ${p === current_page ? 'active' : ''}`}>
          <button type='button' className='page-link cursor-pointer' onClick={() => p !== current_page && setPage(p)}>
            {p}
          </button>
        </li>
      ))}
      {data.length > 0 && data.length === per_page && (
        <>
          <li className='page-item disabled'>
            <span className='page-link d-flex'>
              <IconDots size={22} stroke={1} />
            </span>
          </li>
          <li className='page-item'>
            <button type='button' className='page-link cursor-pointer d-flex' onClick={() => setPage(current_page + 1)}>
              <Trans>next</Trans> <IconChevronRight size={22} stroke={1} />
            </button>
          </li>
        </>
      )}
    </>
  )
}

function TotalPages({ endPage, total_pages, startPage, setPage, current_page }) {
  const showEndGap = endPage < total_pages
  return (
    <>
      {Array.from({ length: endPage - startPage + 1 }, (_, i) => startPage + i).map((p) => (
        <li key={p} className={`page-item ${p === current_page ? 'active' : ''}`}>
          <button type='button' className='page-link cursor-pointer' onClick={() => p !== current_page && setPage(p)}>
            {p}
          </button>
        </li>
      ))}
      {showEndGap && (
        <li className='page-item disabled'>
          <span className='page-link d-flex'>
            <IconDots size={22} stroke={1} />
          </span>
        </li>
      )}
      {current_page < total_pages && (
        <li className='page-item'>
          <button type='button' className='page-link cursor-pointer d-flex' onClick={() => setPage(current_page + 1)}>
            <Trans>next</Trans> <IconChevronRight size={22} stroke={1} />
          </button>
        </li>
      )}
      {current_page < total_pages && (
        <li className='page-item'>
          <button type='button' className='page-link cursor-pointer d-flex' onClick={() => setPage(total_pages)}>
            <Trans>last</Trans> <IconChevronsRight size={22} stroke={1} />
          </button>
        </li>
      )}
    </>
  )
}
